import React, { useState } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const StyledResult = styled(Result)`
  background-color: white;
  padding: 48px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleGoHome = () => {
    setLoading(true);
    navigate('/');
  };

  return (
    <Container>
      <StyledResult
        status="404"
        title="Page Not Found"
        subTitle="The page you're looking for does not exist. Click on the button to go back home."
      />
    </Container>
  );
};

export default NotFound;
